<template>
  <div
    class="wt2-sg wt2-masthead-title"
    :class="{ 'with-template-tag': isStoryboard }"
  >
    <transition name="template-tag-fade">
      <div v-if="isStoryboard" class="wt2-story-template-tag">
        {{ 'generic.storyboard' | culture }}
      </div>
    </transition>

    <input
      class="wt2-text-l2"
      type="text"
      :class="{ '-warning': warning, '-disabled': !editable }"
      :readonly="!editable"
      :maxlength="maxLength"
      :placeholder="placeholder"
      v-tooltip-title="maxLength"
      v-model="curTitle"
      @change="$emit('change', $event)"
      @input="reachMaxLength"
      @keyup.enter="$event.target.blur"
    />
  </div>
</template>

<script>
import app from 'app';
import { mapState } from 'vuex';

const tooltipTitle = {
  update: function (el, binding) {
    // show title only if input value is more or equal to maxLength
    el.title =
      el.value.length >= binding.value
        ? app.culture.generic.MAX_VIDEO_TITLE_REACHED.format(
            app.MAX_TITLE_LENGTH
          )
        : '';
  },
};

export default {
  name: 'MastheadTitle',

  props: {
    editable: { type: Boolean, required: true },
    object: {
      type: Object,
      required: true,
      validator(value) {
        return Object.prototype.hasOwnProperty.call(value, 'title');
      },
    },
  },

  directives: {
    tooltipTitle,
  },

  data() {
    return {
      warning: false,
      curTitle: this.object.title,
      maxLength: app.MAX_TITLE_LENGTH,
    };
  },

  watch: {
    'object.title'(newTitle) {
      if (newTitle !== this.curTitle) {
        this.curTitle = newTitle;
      }
    },
  },

  computed: {
    ...mapState({
      isTemplate: (state) => !!state.story?.isTemplate,
    }),

    isStoryboard() {
      if (this.$props.editable) {
        return this.isTemplate;
      } else {
        return !!this.object.template;
      }
    },

    placeholder() {
      return this.$props.editable && this.isStoryboard
        ? app.culture.masthead.titleForStoryTemplate
        : app.culture.masthead.title;
    },
  },

  methods: {
    reachMaxLength(e) {
      this.warning = e.target.value.length >= this.maxLength;
      // remove warning indication after 3 seconds
      if (this.warning) {
        setTimeout(() => {
          this.warning = false;
        }, 3000);
      }
    },
  },
};
</script>
